import Sidebar from '@/components/Sidebar';
import SubscriptionExpiredOverlay from '@/components/subscription/SubscriptionExpiredOverlay';
import { useSubscription } from '@/hooks/useSubscription';
import { FunctionComponent, PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';

interface iLayoutProps extends PropsWithChildren {}

const Layout: FunctionComponent<iLayoutProps> = ({ children }) => {
  // Populate the subscription atom on app boot so feature gates (and the
  // expired overlay) have data before the user lands on a subscription-aware
  // page. Without this, gates default to FREE until the user visits /subscription.
  useSubscription();

  return (
    <div className='flex h-screen'>
      <Sidebar />
      <div className='flex-1 flex flex-col overflow-x-hidden relative'>
        <SubscriptionExpiredOverlay />
        <Outlet />
        {children}
      </div>
    </div>
  );
};

export default Layout;
